import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const CATEGORIES = [
  { label: "For Him",     cat: "For Men",         featured: "Sauvage Amb 60", span: "md:col-span-7 md:row-span-2 aspect-[4/3] md:aspect-auto" },
  { label: "For Her",     cat: "For Women",       featured: "Flora Amb 55",    span: "md:col-span-5 aspect-[5/4]" },
  { label: "Unisex",      cat: "Unisex",          featured: "Blue de Amb 65",  span: "md:col-span-3 aspect-[4/5]" },
  { label: "For Parties", cat: "For Parties",     featured: "Shanya",          span: "md:col-span-2 aspect-[4/5]" },
  { label: "For Office",  cat: "For Office",      featured: "Honey Oud",       span: "md:col-span-3 aspect-[4/5]" },
  { label: "For Summer",  cat: "For Summer",      featured: "Aqua Amb 52",     span: "md:col-span-4 aspect-[3/2]" },
  { label: "For Winter",  cat: "For Winter",      featured: null,              span: "md:col-span-4 aspect-[3/2]" },
  { label: "All Weather", cat: "For All Weather", featured: "Million Amb 62",  span: "md:col-span-4 aspect-[3/2]" },
];

export const CategoryGrid = () => {
  const [imageByCat, setImageByCat] = useState({});

  useEffect(() => {
    // For each category, fetch the first product in that category to grab its image
    let cancelled = false;
    (async () => {
      const map = {};
      await Promise.all(
        CATEGORIES.map(async (t) => {
          try {
            const r = await api.get("/products", { params: { category: t.cat } });
            const list = r.data || [];
            let pick = null;
            if (t.featured) {
              pick = list.find((p) => p.name.toLowerCase() === t.featured.toLowerCase());
            }
            if (!pick) pick = list[0];
            if (pick) map[t.cat] = { url: pick.image_url, name: pick.name, id: pick.id };
          } catch {}
        })
      );
      if (!cancelled) setImageByCat(map);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <section
      data-testid="category-grid"
      className="border-y border-[#2D2622]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="flex items-end justify-between mb-14 md:mb-20 gap-6">
          <div>
            <p className="text-[11px] tracking-overline uppercase font-bold text-[#D4AF37] mb-4">
              № 01 — Shop by occasion
            </p>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight text-[#F4EAD9]">
              Find your <span className="italic text-[#D4AF37]">moment</span>.
            </h2>
          </div>
          <p className="hidden md:block max-w-xs text-sm text-[#B0A496] leading-relaxed">
            Browse by mood, season, or who&apos;s wearing it. Each composition is hand-decanted into a 30ml flacon.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4">
          {CATEGORIES.map((t) => {
            const img = imageByCat[t.cat];
            return (
              <Link
                key={t.cat}
                data-testid={`cat-tile-${t.cat.toLowerCase().replace(/\s+/g, "-")}`}
                to={`/shop?category=${encodeURIComponent(t.cat)}`}
                className={`relative image-zoom-parent overflow-hidden group bg-[#1F1A17] ${t.span}`}
              >
                {img?.url && (
                  <img
                    src={img.url}
                    alt={img.name || t.label}
                    className="image-zoom absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/65 via-[#000000]/10 to-transparent" />
                <div className="absolute inset-0 p-5 md:p-7 flex flex-col justify-end">
                  <p className="text-[10px] tracking-overline uppercase font-bold text-[#D4AF37] mb-2">
                    Category
                  </p>
                  <p className="font-serif-display text-2xl md:text-4xl text-[#F4EAD9] leading-none">
                    {t.label}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
